import { UserAgent } from '@quentin-sommer/react-useragent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Flex, Image } from 'rebass';
import React, { useState, useRef } from 'react';

import { CoverWrapper } from './styled';
import { acceptedFor } from '../../../story-media/helper';
import { createStoryCoverMedium } from '../../../story-media/actions';
import { getCoverUrl } from '../../helper';
import { selectStory, selectStoryCover } from '../../selectors';
import FileInput from '../../../app/form/hidden-file-input';
import { useRect } from '@reach/rect';
import CoverEditor from 'stories/new/cover/editor';
import useToggle from 'app/hooks/toggle';
import Modal from 'app/modal/v2/index';
import { Label } from 'app/form/formik/text/styled';
import Default_PreviewPhoto from '../../assets/Default_PreviewPhoto.png';
import addImageSvg from '../../new/cover/thumbnails/assets/add-cover-photo.svg';

const CoverPhoto = ({ image, story, ...props }) => {
  const imageUrl = getCoverUrl(story, image);
  const [tmpUrlSrc, setTmpUrlSrc] = useState(null)
  const [isCropping, toggleCropping] = useToggle(false);

  const [selectedFile, setSelectedFile] = useState(null)
  const ref = useRef();
  const rect = useRect(ref);

  return (
    <Box css="position: relative;">
      {isCropping ? <Modal onClose={() => {
        toggleCropping()
      }} bg="white" maxWidth={640} p="20px" mt="0px">
        <Label style={{ mb: "20px", textAlign: "center" }}>Edit Image</Label>
        <CoverEditor
          px="20px"
          src={tmpUrlSrc}
          acceptEdit={cover => {
            URL.revokeObjectURL(tmpUrlSrc);
            setTmpUrlSrc(cover);

            const coverUrl = URL.createObjectURL(cover);
            setTmpUrlSrc(coverUrl)
            setSelectedFile(cover)
          }}
          exitEditor={() => {
            props.createStoryCoverMedium(story.id, selectedFile)
            // loadImage(
            //   selectedFile,
            //   canvas => {
            //     canvas.toBlob(
            //       blob => {
            //         props.createStoryCoverMedium(story.id, blob);
            //       },
            //       'image/png',
            //       100
            //     );
            //   },
            //   {
            //     canvas: true,
            //     aspectRatio: 2 / 1,
            //   }
            // );

            toggleCropping()
          }}
          editorWidth={rect && rect.width}
        />
      </Modal>
        : <Box>
          <Image
            width="100%"
            height="250px"
            sx={{ objectFit: 'contain' }}
            src={imageUrl || Default_PreviewPhoto} ref={ref}
          />
          <Flex>
            <UserAgent android>
              {isAndroid => (
                <FileInput
                  id="upload_cover"
                  accept={isAndroid ? 'image/*' : acceptedFor.images}
                  onChange={e => {
                    e.preventDefault();
                    const file = e.target.files[0];
                    const urlSrc = URL.createObjectURL(file)
                    setTmpUrlSrc(urlSrc)
                    setSelectedFile(file)
                    toggleCropping()
                  }}
                />
              )}
            </UserAgent>
            <Flex as="label" htmlFor="upload_cover" fontFamily="Poppins" alignItems="center" my={1} sx={{ cursor: 'pointer' }}>
              <Image width={40} mr={2} src={addImageSvg} alt="select from gallery" />
              Select from photo library
            </Flex>
          </Flex>
        </Box>
      }
    </Box >
  );
};

CoverPhoto.propTypes = {
  createStoryCoverMedium: PropTypes.func.isRequired,
  story: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  image: PropTypes.shape({
    'upload-url': PropTypes.string,
    started: PropTypes.bool,
    tmpFile: PropTypes.instanceOf(Blob),
  }).isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  story: selectStory(state, ownProps.id),
  image: selectStoryCover(state, ownProps.id) || {},
});

export default connect(
  mapStateToProps,
  { createStoryCoverMedium }
)(CoverPhoto);
